// extracted by mini-css-extract-plugin
export default {"offer":"OfferPaymentBanner_offer__hKUvc"};